import { router } from './router'

export { open, openProblem, editProblem, editProblemInThisWindow }

let  open = function(publicID, name) {
    if(publicID) {
        const parsedId = parseInt(publicID)
        if(!isNaN(parsedId)) {
            let routeData = router.resolve({ name: name, params: { publicID: publicID } })
            window.open(routeData.href, '_blank')
        } else {
            console.log('The id must be an integer')
        }
    } else {
        let routeData = router.resolve({ name: name })
        window.open(routeData.href, '_blank')
    }
}

let  openProblem = function(publicID) { open(publicID, 'Problem') }
let  editProblem = function(publicID) { open(publicID, 'Edit') }

let  editProblemInThisWindow = function(publicID) { 
    router.push({ name: 'Edit', params: { publicID: publicID } })//.catch(()=>{});
}